
import {
  INIT_PROFILE_INFO,
  REQUEST_PROFILE_START,
  REQUEST_PROFILE_SUCCESS,
  REQUEST_PROFILE_FAIL,
} from '../actions/profile'

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_PROFILE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_PROFILE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_PROFILE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_PROFILE_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
